/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseDTOPaginationRecordListUserManagementDTO } from "../models/ApiResponseDTOPaginationRecordListUserManagementDTO";
import type { ApiResponseDTOUserDetailDTO } from "../models/ApiResponseDTOUserDetailDTO";
import type { ApiResponseDTOUserManagementDTO } from "../models/ApiResponseDTOUserManagementDTO";
import type { ApiResponseDTOVoid } from "../models/ApiResponseDTOVoid";
import type { UserDetailsManagementRequestDTO } from "../models/UserDetailsManagementRequestDTO";
import type { UserDetailsRequestDTO } from "../models/UserDetailsRequestDTO";
import type { UserManagementParametersRecord } from "../models/UserManagementParametersRecord";

import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";

export class UserManagementApiService {
  /**
   * Get User Management
   * Retrieves the User Management
   * @param parameters
   * @returns ApiResponseDTOPaginationRecordListUserManagementDTO OK
   * @throws ApiError
   */
  public static getUserManagement(
    parameters: UserManagementParametersRecord
  ): CancelablePromise<ApiResponseDTOPaginationRecordListUserManagementDTO> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/management",
      query: {
        parameters: parameters,
      },
      errors: {
        404: `Not Found`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Create User Management
   * Retrieves the Create User Management
   * @param requestBody
   * @returns ApiResponseDTOUserManagementDTO OK
   * @throws ApiError
   */
  public static createUserManagement(
    requestBody: UserDetailsRequestDTO
  ): CancelablePromise<ApiResponseDTOUserManagementDTO> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/management",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        404: `Not Found`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Delete User Management
   * Delete a User Management
   * @param id
   * @returns ApiResponseDTOVoid OK
   * @throws ApiError
   */
  public static deleteUserManagement(
    id: string
  ): CancelablePromise<ApiResponseDTOVoid> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/management/{id}",
      path: {
        id: id,
      },
      errors: {
        404: `Not Found`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Edit User Management
   * Edit a User Management with its details
   * @param id
   * @param requestBody
   * @returns ApiResponseDTOUserDetailDTO OK
   * @throws ApiError
   */
  public static putUserManagement(
    id: string,
    requestBody: UserDetailsManagementRequestDTO
  ): CancelablePromise<ApiResponseDTOUserDetailDTO> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/management/{id}",
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        404: `Not Found`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }
}
